let en = null;
let zh = null;

export let translate = (lang, key) => {
    switch (lang) {
        case "EN":
            if (en === null) {
                en = require("./language/en").default;
            }
            if (en[key]) {
                return en[key];
            } else {
                return key;
            }

        case "ZH":
            if (zh === null) {
                zh = require("./language/zh_cn").default;
            }
            if (zh[key]) {
                return zh[key];
            } else {
                return key;
            }
        default:
            if (en === null) {
                en = require("./language/en").default;
            }
            if (en[key]) {
                return en[key];
            } else {
                return key;
            }
    }
};